/* eslint-disable */
const richTextEditorConfig = {
    icons: 'material',
    relative_urls: false,
    remove_script_host: false,
    skin: false,
    content_css: false,
    invalid_elements: 'script, noscript',
    menubar: false,
    browser_spellcheck: true,
    insertdatetime_formats: ['%H:%M:%S', '%Y-%m-%d', '%I:%M:%S %p', '%D'],
    fontsize_formats: '11px 12px 14px 16px 18px 24px 36px 48px',
    forced_root_block: true,
    force_br_newlines: true,
    toolbar_mode: 'sliding',
    plugins: 'lists insertdatetime table searchreplace charmap advlist link paste autoresize',
    statusbar: false,
    branding: false,
    theme: 'silver',
    contextmenu: false,
    paste_as_text: false,
    cache_suffix: `?v=${process.env.REACT_APP_VERSION}`,
    entity_encoding: 'raw',
    autoresize_bottom_margin: 50,
    autoresize_overflow_padding: 1,
    font_formats:
      'Andale Mono=andale mono,times;Arial=arial,helvetica,sans-serif;Arial Black=arial black,avant garde;' +
      'Book Antiqua=book antiqua,palatino;Comic Sans MS=comic sans ms,sans-serif;Courier New=courier new,courier;' +
      'Georgia=georgia,palatino;Helvetica=helvetica;Impact=impact,chicago;Open Sans=Open Sans;' +
      'Sans-Serif=sans-serif;Tahoma=tahoma,arial,helvetica,sans-serif;Terminal=terminal,monaco;' +
      'Times New Roman=times new roman,times;Trebuchet MS=trebuchet ms,geneva;Verdana=verdana,geneva',
    toolbar:
      'undo redo | cut copy paste pastetext | bold italic underline strikethrough | fontselect fontsizeselect | forecolor backcolor | ' +
      'alignleft aligncenter alignright alignjustify | bullist numlist | outdent indent | superscript subscript' +
      '| link removeformat insertdatetime searchreplace charmap table',
    defaultToolbar:
      'undo redo | cut copy paste pastetext | bold italic underline strikethrough | fontselect fontsizeselect | forecolor backcolor | ' +
      'alignleft aligncenter alignright alignjustify | bullist numlist | outdent indent | superscript subscript' +
      '| link removeformat insertdatetime searchreplace charmap table',
    mobile: {
      toolbar_mode: 'sliding',
      toolbar: 
        'undo redo | cut copy paste pastetext | bold italic underline strikethrough | forecolor backcolor | fontselect fontsizeselect ' +
        '| alignleft aligncenter alignright alignjustify | bullist numlist | outdent indent | superscript subscript' +
        '| link removeformat insertdatetime searchreplace charmap table',
      font_formats:
        'Andale Mono=andale mono,times;Arial=arial,helvetica,sans-serif;Arial Black=arial black,avant garde;' +
        'Book Antiqua=book antiqua,palatino;Comic Sans MS=comic sans ms,sans-serif;Courier New=courier new,courier;' +
        'Georgia=georgia,palatino;Helvetica=helvetica;Impact=impact,chicago;Open Sans=Open Sans;' +
        'Sans-Serif=sans-serif;Tahoma=tahoma,arial,helvetica,sans-serif;Terminal=terminal,monaco;' +
        'Times New Roman=times new roman,times;Trebuchet MS=trebuchet ms,geneva;Verdana=verdana,geneva'
    }
};
/* eslint-enable */

export default richTextEditorConfig;
